import InstantArticleScriptTag from '../../../../../common/InstantArticleScriptTag'
import InstantArticleScriptNotes from '../../../../../common/InstantArticleScriptNotes'

import * as React from 'react'

const InstantArticleScript: React.FunctionComponent = () => {
	return (
		<>
			<div style={{ marginTop: '10px', marginBottom: '10px' }}>
				<span
					style={{
						marginTop: 0,
						fontSize: '1.5em',
						paddingRight: '10px',
					}}
				>
					<i className="fa fa-exclamation-triangle text-warning" />
				</span>
				<span className="text-warning">
					<b>
						NOTE: Instant Article requires the following script to be placed on every landing page you
						direct traffic to:
					</b>
				</span>
			</div>
			<pre>
				<code>
					<InstantArticleScriptTag />
				</code>
			</pre>
			<InstantArticleScriptNotes />
		</>
	)
}

export default InstantArticleScript
